import { create } from "@bufbuild/protobuf";
import { Code } from "@connectrpc/connect";

import { PaginationRequest, PaginationRequestSchema } from "@gx/ts-contracts/shared/pagination_pb";
import {
  SortBy,
  SortingRequest,
  SortingRequestSchema,
  SortOrder,
} from "@gx/ts-contracts/shared/sorting_pb";

export const DEFAULT_PAGINATION_TOTAL = 25;
export const DEFAULT_PAGINATION_CURSOR = "0";
export const DEFAULT_SORT_BY = SortBy.CREATED_AT;
export const DEFAULT_SORT_ORDER = SortOrder.DESC;

export const DEFAULT_PAGINATION_REQUEST: PaginationRequest = create(PaginationRequestSchema, {
  total: DEFAULT_PAGINATION_TOTAL,
  cursor: DEFAULT_PAGINATION_CURSOR,
});
export const DEFAULT_SORTING_REQUEST: SortingRequest = create(SortingRequestSchema, {
  sortBy: DEFAULT_SORT_BY,
  sortOrder: DEFAULT_SORT_ORDER,
});

export const ERROR_MESSAGES: Record<Code, string> = {
  [Code.Canceled]: "The operation was cancelled",
  [Code.Unknown]: "An unknown error occurred",
  [Code.InvalidArgument]: "Invalid request data",
  [Code.DeadlineExceeded]: "Request timeout - please try again",
  [Code.NotFound]: "Resource not found",
  [Code.AlreadyExists]: "Resource already exists",
  [Code.PermissionDenied]: "Permission denied",
  [Code.ResourceExhausted]: "Service is currently overloaded - please try again later",
  [Code.FailedPrecondition]: "Operation cannot be completed in current state",
  [Code.Aborted]: "Operation was aborted - please try again",
  [Code.OutOfRange]: "Value is out of valid range",
  [Code.Unimplemented]: "This feature is not yet implemented",
  [Code.Internal]: "Internal server error - please try again",
  [Code.Unavailable]: "Service is temporarily unavailable - please try again",
  [Code.DataLoss]: "Data loss detected - please contact support",
  [Code.Unauthenticated]: "Authentication required - please log in",
};
